/*global language*/
import axios from 'axios'

const baseDomain = ''
const version = '1'
const apiLang = language.current !== 'de' ? `/${language.current}` : ''
const namespace = `planyo/v${version}`
const baseURL = `${baseDomain}${apiLang}/wp-json/${namespace}`

const Service = axios.create({
  baseURL,
})

export default {
  async getAll() {
    const resp = await Service.get()
    const data = resp.data

    return data
  },

  async getExampleData($params) {
    const params = {
      action: 'wm_aks_planyo',
      ...$params,
    }

    const resp = await Service.get('', {
      params: params,
    })

    return resp.data
  },

  async resourceSearch($params) {
    const resp = await Service.get('/resource_search', {
      params: $params,
    })

    return resp.data
  },

  async resourceUsage($params) {
    const resp = await Service.get('/resource_usage', {
      params: $params,
    })

    return resp.data
  },

  async createCart($params) {
    const resp = await Service.get('/create_cart', {
      params: $params,
    })

    return resp.data
  },

  async makeReservation($params) {
    const resp = await Service.get('/make_reservation', {
      params: $params,
    })

    return resp.data
  },

  async validateVoucher($params) {
    const resp = await Service.get('/list_vouchers', {
      params: $params,
    })

    return resp.data
  },

  async getPaymentFormUrl($reservation_id) {
    const resp = await Service.get('/payment_url', {
      params: {
        reservation_id: $reservation_id,
      },
    })

    return resp.data
  },

  async getBasketList($shopping_cart_id) {
    const resp = await Service.get('/get_cart_items', {
      params: {
        shopping_cart_id: $shopping_cart_id,
        language: language.current,
      },
    })

    return resp.data
  },

  async getPaymentTemplate($reservation_id) {
    const resp = await Service.get('/payment_template', {
      params: {
        reservation_id: $reservation_id,
        language: language.current,
      },
    })

    return resp.data
  },
}
